<template>
  <div class="equity-change-details">
    <component :is="component" />
  </div>
</template>

<script>
import EquityChangeDetailsHk from './EquityChangeDetailsHk.vue'
import EquityChangeDetailsUs from './EquityChangeDetailsUs.vue'
import EquityChangeDetailsHs from './EquityChangeDetailsHs.vue'

const components = {
  hk: EquityChangeDetailsHk,
  hs: EquityChangeDetailsHs,
  us: EquityChangeDetailsUs
}
export default {
  computed: {
    symbol() {
      return this.$route.query.symbol
    },
    market() {
      return this.$funs.getMarket(this.symbol)
    },
    component() {
      return components[this.market]
    }
  }
}
</script>

<style>
.equity-change-details {
  height: calc(100vh - 48px);
  background: var(--bg-color-2);
}
</style>
